import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ApiService } from 'src/app/core/api.service';
import { LoggerService } from 'src/app/core/logger.service';
import { LinkFileListService } from 'src/app/link-consume/services/link-file-list.service';
import { BlendService } from 'src/app/shared/services/blend.service';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { BuildTransferItemService } from 'src/app/transfer/services/build-transfer-item.service';
import { TransferService } from 'src/app/transfer/services/transfer.service';
import { IFile, ITransferItemDownload, ITransferView } from 'src/sync';
import { BrowserSupportService } from 'src/app/core/browser-support.service';
import { ErrCode, FileItem } from 'src/app/shared/models';
import { TransferStatus } from 'src/app/transfer/models/transfer.model';
import { FileItemService } from '../../file-item.service';
@Component({
  selector: 'app-preview-dialog',
  templateUrl: './preview-dialog.component.html',
  styleUrls: ['./preview-dialog.component.scss']
})
export class PreviewDialogComponent implements OnInit{

  @Input() public type: string;
  @Input() public item: IFile;
  @Input() public locId: number;

    public imageURL: SafeUrl;
    public transferView: ITransferView;
    public initialized = false;
    public transferItem: ITransferItemDownload;
    public btFile = { renderFile: { dl_ready: false } };
    public errorMsg: string;
    public errcode: ErrCode;
    public btFileSpinner = false;
  
  constructor(
    private BrowserSupportService: BrowserSupportService,
    private loggerService: LoggerService,
    private transferService: TransferService,
    private buildTransferItemService: BuildTransferItemService,
    private linkFileListService: LinkFileListService,
    private sanitizer: DomSanitizer,
    private apiService: ApiService,
    private blendService: BlendService,
    private broadcastService: BroadcastService,
    private fileItemService: FileItemService,
    
  ) { }

    bypassSecurityTrustUrl() {
      if (this.transferView.single.renderFile.url) {
        this.imageURL = this.sanitizer.bypassSecurityTrustUrl(this.transferView.single.renderFile.url);
      }
      if (this.item.compaturl) {
        this.imageURL = this.sanitizer.bypassSecurityTrustUrl(this.item.compaturl);
      }
    }
    ngOnInit(): void {
      console.log('preview-dialog.component');
      
    this.initialize();

    }

      private async watch(pathitem: FileItem) {
        this.transferItem = undefined;
        this.initialized = false;
        if (pathitem) {
          try {
            this.btFile = { renderFile: { dl_ready: false } };
            const modifiedPathItem = { ...pathitem };
            modifiedPathItem.blobtype = modifiedPathItem.has_thumb2 && modifiedPathItem.size > 100 * 1024
                ? 'btTHUMB2'
                : 'btFILE';
            const tItem = await this.transferService.getFile(modifiedPathItem, true);
            // GetFile for appLink doesn't properly set this.Transferview.single for URL in open.
            if (
              tItem.status == TransferStatus.STATUS_ERR_SIZE ||
              tItem.status == TransferStatus.STATUS_ERR_OPEN
            ) {
              this.errorMsg = 'Unable to view this file.';
              this.transferView.cannotViewSave = true;
            }
            if (tItem.linkID) {
              this.loggerService.info('Consume link');
              this.apiService.execute('linkconsume', {
                links: [{ publink_id: tItem.linkID }],
              });
            }
            this.initialized = true;
          } catch (err) {
            this.errcode = ErrCode.fromException(err);
            this.transferView.cannotViewSave = true;
            if (err.errors) {
              this.errorMsg = err.errors[0].error_msg;
            } else {
              this.errorMsg = 'Unable to view this file.';
            }
          }
        } else {
          this.initialized = true;
          this.item = undefined;
          this.btFileSpinner = false;
          this.btFile = { renderFile: { dl_ready: false } };
          this.errorMsg = 'Invalid file provided';
        }
        this.bypassSecurityTrustUrl();
      }
      public navigate(item: FileItem) {
        // this.items.current = item;
        this.watch(item);
        // this.getNextPrevItems(item);
        // this.getCurrentFile.next(item);
      }
      private async initialize() {
        this.errorMsg = '';
        this.initialized = false;
        this.transferItem = undefined;
        const pathget = this.item;
        // this.item = await this.fileItemService.format(pathget);
        await this.buildTransferItemService.getStreamingDetails(this.item);
        this.transferView = this.buildTransferItemService.view; 
        this.navigate(this.item);
      }
}
